import { Form, Input, Button, Row, Col } from "antd";

const FilterCrewMember = ({ onFilter, filterType }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const filters = {
      employeeName: values.employeeName || null,
      employeeCode: values.employeeCode || null
    };
    onFilter(filters);
  };

  const handleReset = () => {
    form.resetFields();
    onFilter({});
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical" style={{ margin: "1rem"}} autoComplete="off">
      <Row gutter={16} style={{ alignItems: "center"}}>
        <Col span={6}>
          <Form.Item name="employeeName" label="Employee Name">
            <Input placeholder="Enter Employee Name" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="employeeCode" label="Employee Code">
            <Input placeholder="Enter Employee Code" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Button type="primary" htmlType="submit">Apply Filters</Button>
          <Button onClick={handleReset} style={{ marginLeft: 8 }}>Reset</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default FilterCrewMember;
